import { useCallback } from 'react'
import { CIMSBasicFieldProps } from '../../types'
import PayItemTags from '../../../CIMSTags/common/PayItemTags'
import { CIMSTags } from '../../../CIMSTags'
import LinksSpaceCIMSBasicField from './components/LinksSpaceCIMSBasicField'
import CheckboxCIMSBasicField from './components/CheckboxCIMSBasicField'
import ProjectLink from '../../../ProjectLink'
import CIMSLink from '../../../CIMSLink'
import { dateFormatter } from '../../../../utils/dateFormatter'

/**
 * a callback to resolve the various unions associated with {@link CIMSBasicFieldProps}
 */
export function useItemCallback() {
  return useCallback((field: CIMSBasicFieldProps) => {
    if (field.type === 'date') {
      const { date, format } = field
      return date ? dateFormatter[format ?? 'simple'](date) : ''
    } else if (field.type === 'payItems') {
      const { payItems } = field
      return <PayItemTags payItems={payItems} />
    } else if (field.type === 'deepLink') {
      const { type, label, hidden, help, linkLabel, page, ...rest } = field
      return (
        <ProjectLink {...rest} item={page}>
          {linkLabel}
        </ProjectLink>
      )
    } else if (field.type === 'deepLinks') {
      return (
        <LinksSpaceCIMSBasicField
          {...field}
          links={field.links.map((link) => ({ ...link, type: 'deep' }))}
        />
      )
    } else if (field.type === 'checkbox')
      return <CheckboxCIMSBasicField {...field} />
    else if (field.type === 'tags') {
      const { type, label, hidden, help, ...rest } = field
      return <CIMSTags {...rest} />
    } else if (field.type === 'externalLink') {
      const { type, label, hidden, help, linkLabel, ...rest } = field
      return (
        <CIMSLink external {...rest}>
          {linkLabel}
        </CIMSLink>
      )
    } else if (field.type === 'externalLinks') {
      return (
        <LinksSpaceCIMSBasicField
          {...field}
          links={field.links.map((link) => ({ ...link, type: 'external' }))}
        />
      )
      // coalescing here because if all children are null/undefined the value
      // column collapses completely
    } else return field.children ?? ''
  }, [])
}
